import { action, observable } from "mobx"

import { Model } from "@/lib/Model.ts"

import type { ResolvedAttachment } from "@/components/Chat/Attachments.tsx"
import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"
import type { IObservableValue } from "mobx"


export class UserMessageModel extends Model {
  readonly resolvedAttachments: IObservableValue<ResolvedAttachment[]>
  readonly isExpanded = observable.box(false)

  constructor(private readonly content: AiChatMessageContent.Text) {
    super("UserMessageModel")

    this.resolvedAttachments = observable.box<ResolvedAttachment[]>(this.content.attachments.map(attachment => ({
      status: "resolved" as const,
      promise: Promise.resolve(attachment),
      result: attachment
    } as ResolvedAttachment)))
  }

  toggleExpanded = action(() => {
    this.isExpanded.set(!this.isExpanded.get())
  })
}